import React from "react";
import logo from "./assets/logo10years.png";

const ThankYouSection = () => {
  const containerStyle = {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "100vh",
    backgroundColor: "#ffffff",
    textAlign: "center",
    padding: "0 24px",
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
  };

  const logoContainerStyle = {
    marginBottom: "24px", // Matches the spacing below the title
    cursor: "pointer",
  };

  const logoStyle = {
    height: "80px", 
    width: "auto",
  };

  const headingStyle = {
    fontSize: "42px",
    fontWeight: "700",
    color: "#009688", 
    marginBottom: "24px", // This is the reference spacing
  };

  const paragraphStyle = {
    fontSize: "18px",
    color: "#333333",
    lineHeight: "1.6",
    maxWidth: "800px",
    marginBottom: "16px",
  };

  return (
    <div style={containerStyle}>
      {/* Logo Container */}
      <div style={logoContainerStyle}>
        <a href="https://thestartupzone.in/" target="_blank" rel="noopener noreferrer">
          <img 
            src={logo} 
            alt="The Startup Zone Logo" 
            style={logoStyle} 
          />
        </a>
      </div>

      <h1 style={headingStyle}>Thank You for Connecting with Us!</h1>

      <p style={paragraphStyle}>
        Thank you for reaching out to us! We’re excited to hear about your
        interest in our services, and we want to assure you that we’re here to
        make this journey as smooth as possible.
      </p>

      <p style={paragraphStyle}>
        We’ve received your request regarding Services, and our team will review
        it soon. We aim to provide you with the best solution tailored to your
        needs, and you can expect to hear from us shortly with the next steps.
      </p>
    </div>
  );
};

export default ThankYouSection;